"use client";

import { Button } from "@decibeltrade/web-core/components";
import { ModalContent, ModalRenderProps, openModal } from "@decibeltrade/web-core/modal";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
import { css } from "styled-system/css";
import { stack } from "styled-system/patterns";

import { useWalletNetworkMismatch } from "@/hooks/use-wallet-network-mismatch";

import { getSdkNetworkName, sdkConfig } from "./dex-sdk";
import { useWriteDexSdk } from "./write-dex-sdk-context";

const currentNetworkName = getSdkNetworkName(sdkConfig);
const currentChainId = sdkConfig.chainId;

// TODO: Re-enable once we support proper network detection for all wallet types
const NETWORK_MISMATCH_MODAL_ENABLED = false;

export function WalletMismatchModal() {
  const hasNetworkMismatch = useWalletNetworkMismatch(currentNetworkName, currentChainId);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!NETWORK_MISMATCH_MODAL_ENABLED) {
      return;
    }
    if (hasNetworkMismatch) {
      openModal({
        id: "wallet-mismatch-modal",
        renderContent: (modalProps) => <WalletMismatchModalContent {...modalProps} />,
        dismissible: false,
      });
    }
  }, [hasNetworkMismatch]);

  return null;
}

function WalletMismatchModalContent({ close }: ModalRenderProps) {
  const t = useTranslations("walletSelector");

  const hasNetworkMismatch = useWalletNetworkMismatch(currentNetworkName, currentChainId);
  const { disconnect } = useWriteDexSdk();

  useEffect(() => {
    if (!hasNetworkMismatch) {
      close();
    }
  }, [hasNetworkMismatch, close]);

  const onDisconnect = () => {
    disconnect();
    close();
  };

  return (
    <ModalContent className={stack({ w: "[359px]", p: "16", gap: "24" })}>
      <div className={stack({ gap: "12", pt: "12", textAlign: "center" })}>
        <h2 className={css({ textStyle: "heading.3xs" })}>{t("incorrectWalletNetwork")}</h2>
        <p className={css({ textStyle: "body.md" })}>
          {t("incorrectWalletNetworkDescription", { desiredWalletName: currentNetworkName })}
        </p>
      </div>
      <Button variant="secondary" onClick={onDisconnect}>
        {t("disconnect")}
      </Button>
    </ModalContent>
  );
}
